export default "__VITE_ASSET__BGRvpyz___"